import styled from 'styled-components/native';

import KeyboardAvoidingView from '@src/components/KeyboardAvoidingView';
import { H1 } from '@src/components/Typography';

export const Container = styled(KeyboardAvoidingView).attrs(() => ({
  contentContainerStyle: {
    flex: 1,
    justifyContent: 'space-between',
  },
}))`
  flex: 1;
  justify-content: space-between;
`;

export const Wrapper = styled.View``;

export const Title = styled(H1)`
  margin-bottom: 20px;
`;
